module.exports = function () { /* empty */ };



//////////////////
// WEBPACK FOOTER
// ./~/_core-js@2.6.12@core-js/library/modules/_add-to-unscopables.js
// module id = 433
// module chunks = 1